import React, { Component } from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import history from './history';
import SignInPage from './account/SignInPage';
import AlertsPage from './analytics/AlertsPage';
import MetricsPage from './analytics/MetricsPage';

export default class Index extends Component {

    render() {
      return (
        <Router history={history}>
            <Switch>
                <Route path="/Analytics/Alerts" component={AlertsPage} />
                <Route path="/Analytics/Metrics" component={MetricsPage} />
                <Route path="/" component={SignInPage} />
            </Switch>
        </Router>
      );
    }
  
  }


// WEBPACK FOOTER //
// ./src/routes/Index.js